import {
  BadRequestHttpErrorResponse,
  HttpErrorHandlerFn,
  isBadRequest,
} from '@web/common';
import { inject } from '@angular/core';
import { BadRequestErrorMessageProviderService } from '../providers/bad-request-error-message-provider.service';
import { BadRequestErrorCode } from '../types/bad-request-error-code';
import { BadRequestErrorMessageParameter } from '../enums/bad-request-error-message-parameter';

/* prettier-ignore */
export const BadRequestHttpErrorHandler: HttpErrorHandlerFn = (error) => {
  const provider = inject(BadRequestErrorMessageProviderService);

  if (isBadRequest(error)) {
    const response = BadRequestHttpErrorResponse.fromResponse<BadRequestErrorCode, BadRequestErrorMessageParameter>(error);

    try {
      const params = Object.entries(response.parameters).reduce((result, [parameter, value]) => ({ ...result, ...{ [parameter]: value }}), {} as Record<BadRequestErrorMessageParameter, string>);
      const result = provider.message(response.code, params);

      return [result];
    } catch (e) {
      return [`Nieobsługiwany kod błędu "${response.code}".`];
    }
  }

  return null;
};
